import { FC } from 'react';
import dateFnsFormat from 'date-fns/format';

const DateFormatter: FC<{ date?: string; format: string }> = ({
	date,
	format,
}) => <time>{date && dateFnsFormat(Date.parse(date), format)}</time>;

export default DateFormatter;
